document.addEventListener('DOMContentLoaded', () => {
  const modals = document.querySelectorAll('.modal')
  if (modals) {
    modals.forEach(modal => {
      const checkKey = (e) => {
        if (e.key === 'Escape') {
          modal.dispatchEvent(new Event('closeModal'))
        }
      }
      const closeModal = (e) => {
        if (modal === e.target) {
          modal.dispatchEvent(new Event('closeModal'))
        }
      }

      modal.addEventListener('openModal', () => {
        modal.classList.add('modal--open')
        document.body.style.overflow = 'hidden'
        modal.addEventListener('click', closeModal)
        window.addEventListener('keydown', checkKey)
      })

      modal.addEventListener('closeModal', () => {
        modal.classList.remove('modal--open') 
        document.body.style.setProperty("overflow", "hidden auto", "important")
        modal.removeEventListener('click', closeModal)
        window.removeEventListener('keydown', checkKey)
      })

      const closeButton = modal.querySelector('.modal__close')
      if (closeButton) {
        closeButton.addEventListener('click', () => {
          modal.dispatchEvent(new Event('closeModal'))
        })
      }
    })

    const modalOpenButtons = document.querySelectorAll('[data-open-modal]')
    if (modalOpenButtons) {
      modalOpenButtons.forEach(button => {
        const nameModal = button.getAttribute('data-open-modal')
        if (nameModal) {
          button.addEventListener('click', () => {
            modals.forEach(modal => {
              if (modal.getAttribute('data-modal-name')?.trim() === nameModal) {
                modal.dispatchEvent(new Event('openModal'))
              }
            })
          })
        }
      })
    }
  }
})
